import React from "react";
 
export const Background = () => {
  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #000021, #010024)",
      }}
    ></div>
  );
};